
import { CertificateReport } from "./components/certificate-report/certificate-report"
import { AnalyticsListener } from "./analytics"

export const App = () => (
      <>
        <AnalyticsListener />
        <CertificateReport />
      </>
)
